import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import { TxpDatapoint } from 'txp-data';

export const MAX_TITLE_LENGTH = 230;
export const reservationForNamePath = 'reservationFor.name';
export const lodgingStreetAdressPath = 'reservationFor.address.streetAddress';
export const serviceReservationStreetAdressPath = 'reservationFor.location.address.streetAddress';
export const serviceReservationPostalCodePath = 'reservationFor.location.address.postalCode';
export const serviceReservationAddressLocalityPath =
    'reservationFor.location.address.addressLocality';
export const serviceReservationAddressRegionPath = 'reservationFor.location.address.addressRegion';
export const serviceReservationAddressCountryPath =
    'reservationFor.location.address.addressCountry';

export const editableFlagCustomData: TxpDatapoint = { [LogNames.isEditable]: 'true' };
